<template>
    <div class="feature-slider owl-carousel nav-center">
        <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
            <Slide v-for="item in ManVan" :key="item.id">
                <div class="service-item">
                    <div class="service-img">
                        <div class="img-slider owl-carousel nav-center">
                            <Carousel :wrap-around="true" :settingsOne="settingsOne" :breakpointsOne="breakpointsOne">
                                <Slide v-for="slideItem in item.Slider" :key="slideItem.id">
                                    <div class="slide-images">
                                        <router-link to="/details/service-details">
                                            <img :src="require(`@/assets/img/services/${slideItem.Image}`)" class="img-fluid" alt="img">
                                        </router-link>
                                    </div>
                                </Slide>
                                <template #addons>
                                    <Navigation />
                                    <Pagination />
                                </template>
                            </Carousel>
                        </div>
                        <div class="fav-item d-flex align-items-center justify-content-between w-100">
                            <a href="javascript:void(0);" class="avatar avatar-md">
                                <img :src="require(`@/assets/img/profiles/${item.Avatar}`)" class="rounded-circle" alt="User">
                            </a>
                            <a href="javascript:void(0);" class="fav-icon">
                                <i class="ti ti-heart"></i>
                            </a>
                        </div>
                    </div>
                    <div class="service-content text-start">
                        <h6 class="mb-1 text-truncate"><router-link to="/details/service-details">{{item.Title}}</router-link></h6>
                        <div class="d-flex align-items-center justify-content-between">
                            <p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>{{item.Reviews}}</p>
                            <small>{{item.Price}}</small>
                        </div>
                    </div>
                </div>
            </Slide>
            <template #addons>
                <Navigation />
            </template>
        </Carousel>
    </div>
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import ManVan from '@/assets/json/frontend/man-van.json'
import "vue3-carousel/dist/carousel.css";

export default {
    data() {
        return {
            ManVan: ManVan,
            settings: {
            itemsToShow: 1,
            snapAlign: "center",
        },
        breakpoints: {
            575: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            767: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            991: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            1024: {
                itemsToShow: 4,
                snapAlign: "start",
            },
        },
        settingsOne: {
            itemsToShow: 1,
            snapAlign: "center",
        },
        breakpointsOne: {
            575: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            767: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            991: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            1024: {
                itemsToShow: 3,
                snapAlign: "start",
            },
        },
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination,
    },
}
</script>